import React, { useCallback, useEffect, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { GoCreditCard } from "react-icons/go";
import HTTP_BASE_URL from "../constants/HttpConstants";

const AmountHistory = ({ close, id }) => {
  
  const customertoken = localStorage.getItem("customertoken");
  const [amountHistoryView, setAmountHistoryView] = useState("");

  const getPaymentHistory = useCallback(async () => {
    const formData = new FormData();
    formData.append("id", id);
    try {
      await fetch(HTTP_BASE_URL + "getPaymentHistory", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            // console.log(result.data);
            setAmountHistoryView(result.data);
          }
        });
    } catch (error) {
      console.error(error);
    }
  }, [id, customertoken]);

  useEffect(() => {
    getPaymentHistory();
  }, [getPaymentHistory]);

  return (
    <>
      <div className="fromModel">
        <div className="billingModal-content payment-history">
          <div className="div">
            <div className="gstModel-header">
              <p className="h5-title icons ">
                <GoCreditCard style={{ marginBottom: "6px" }} />
                Payment History
              </p>
              <div className="btn-close" onClick={() => close(false)}>
                <AiOutlineCloseCircle />
              </div>
            </div>
            <div className="modal-body">
              <div style={{ overflow: "auto" }}>
                <table className="w-100 text-start">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {amountHistoryView.length > 0 ? (
                      amountHistoryView
                      .slice() // Create a shallow copy to avoid mutating the original array
                      .reverse() // Reverse the array to show the latest item first
                      .map((item, index) => (
                        <tr key={index}>
                          <td>{item.created_at}</td>
                          <td>₹{item.amount}</td>
                          <td
                            className={
                              item.payment_status_name === "Paid"
                                ? "green"
                                : "red"
                            }
                          >
                            {item.payment_status_name}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No records found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AmountHistory;
